import React from "react";
import { Spinner } from "reactstrap";

export const LoadingSpinner: React.FC = () => {
  return (
    <>
    <div className="loader h-3 w-3 rounded-full border-2 border-gray-200 ease-linear"></div>
    </>
  );
};

export const FetchingResults: React.FC = () => {
  return (
    <>
    {/* <div className="loader h-3 w-3 rounded-full border-2 border-gray-200 ease-linear"></div> */}
    <Spinner />
    Fetching results...
    </>
  );
};